// src/components/CreateSeasonForm.js
import React, { useState } from 'react';
import { createSeason } from '../services/api';

export default function CreateSeasonForm({ onSeasonCreated }) {
  const [name, setName] = useState('');
  const [startDate, setStartDate] = useState('');
  const [endDate, setEndDate] = useState('');
  const [message, setMessage] = useState('');

  const handleSubmit = async (e) => {
    e.preventDefault();
    setMessage('Создание...');
    try {
      await createSeason({ name, startDate, endDate });
      setMessage('Сезон успешно создан!');
      setName('');
      setStartDate('');
      setEndDate('');
      onSeasonCreated(); // Обновляем список сезонов в родительском компоненте
    } catch (error) {
      setMessage('Ошибка при создании сезона.');
      console.error(error);
    }
  };

  return (
    <div className="create-season-form">
      <h5>Создать новый сезон</h5>
      <form onSubmit={handleSubmit}>
        <input type="text" value={name} onChange={e => setName(e.target.value)} placeholder="Название сезона (ОСЕНЬ 2025)" required />
        <div className="date-inputs">
          <input type="date" value={startDate} onChange={e => setStartDate(e.target.value)} required />
          <input type="date" value={endDate} onChange={e => setEndDate(e.target.value)} required />
        </div>
        <button type="submit">Создать</button>
      </form>
      {message && <p className="admin-message">{message}</p>}
    </div>
  );
}